import BrandMark from "@/components/site/BrandMark";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[var(--bg)] border-t border-[var(--border-subtle)] section-pad py-16 md:py-24"
    >
      <div className="grid md:grid-cols-12 gap-10 mb-16">
        <div className="md:col-span-5">
          <div className="flex items-start gap-5 mb-8">
            <BrandMark height={88} />
            <div className="pt-2">
              <h3 className="font-display text-3xl md:text-5xl text-neutral-100 leading-[0.95]">
                GMB Graniti
                <br />
                <span className="italic font-editorial font-normal text-[var(--accent)]">
                  Cava di Sienite.
                </span>
              </h3>
            </div>
          </div>
          <p className="text-neutral-500 text-sm max-w-md leading-relaxed">
            Erede delle Antiche Cave Balma · 1840—1979. Estrazione e
            lavorazione della sienite della Valle Cervo, oggi attiva a Sagliano
            Micca (BI).
          </p>
        </div>
        <div className="md:col-span-2">
          <p className="text-[0.65rem] tracking-[0.3em] uppercase text-neutral-500 mb-4">
            Naviga
          </p>
          <ul className="space-y-2 text-sm text-neutral-300">
            <li><a href="#storia" className="hover:text-[var(--accent)]">Storia</a></li>
            <li><a href="#sienite" className="hover:text-[var(--accent)]">Sienite</a></li>
            <li><a href="#localizzazione" className="hover:text-[var(--accent)]">Località</a></li>
            <li><a href="#contatti" className="hover:text-[var(--accent)]">Contatti</a></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="text-[0.65rem] tracking-[0.3em] uppercase text-neutral-500 mb-4">
            Contatti
          </p>
          <ul className="space-y-2 text-sm text-neutral-300">
            <li>
              <a href="tel:+390152477195" className="hover:text-[var(--accent)]">
                015 2477195
              </a>
            </li>
            <li>
              <a href="mailto:gmbgranitisrl@gmail.com" className="hover:text-[var(--accent)] break-all">
                gmbgranitisrl@gmail.com
              </a>
            </li>
            <li>
              <a href="mailto:gmbgraniti@pec.it" className="hover:text-[var(--accent)] break-all">
                gmbgraniti@pec.it
              </a>
              <span className="text-[0.65rem] tracking-[0.2em] uppercase text-neutral-500 ml-2">PEC</span>
            </li>
            <li className="text-xs text-neutral-500 pt-2">
              Lun—Ven · 08—12 / 14—16
            </li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="text-[0.65rem] tracking-[0.3em] uppercase text-neutral-500 mb-4">
            Sede legale
          </p>
          <p className="text-sm text-neutral-300 leading-relaxed">
            Via F. Rosazza 4
            <br />
            13816 Sagliano Micca (BI)
            <br />
            Piemonte · Italia
          </p>
        </div>
      </div>

      <div className="divider mb-6" />

      {/* Legal data row */}
      <div className="grid md:grid-cols-4 gap-6 text-xs text-neutral-500 mb-6">
        <div>
          <p className="text-[0.6rem] tracking-[0.25em] uppercase text-neutral-600 mb-1">
            Ragione sociale
          </p>
          <p className="text-neutral-300">GMB Graniti s.r.l.</p>
        </div>
        <div>
          <p className="text-[0.6rem] tracking-[0.25em] uppercase text-neutral-600 mb-1">
            P. IVA · C.F.
          </p>
          <p className="text-neutral-300">02753730023</p>
        </div>
        <div>
          <p className="text-[0.6rem] tracking-[0.25em] uppercase text-neutral-600 mb-1">
            REA
          </p>
          <p className="text-neutral-300">BI-306236</p>
        </div>
        <div>
          <p className="text-[0.6rem] tracking-[0.25em] uppercase text-neutral-600 mb-1">
            Capitale sociale
          </p>
          <p className="text-neutral-300">€ 10.000,00 i.v.</p>
        </div>
      </div>

      <div className="divider mb-6" />

      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-neutral-500 mb-10">
        <p>© {new Date().getFullYear()} GMB Graniti s.r.l. · Tutti i diritti riservati.</p>
        <p className="tracking-[0.2em] uppercase">Sagliano Micca · Biella · Italia</p>
      </div>

      {/* SEO keyword block — visible but discreet, helps indexing */}
      <div
        data-testid="seo-keywords"
        className="text-[0.7rem] leading-relaxed text-neutral-600 max-w-6xl mb-10 space-y-4"
      >
        <div>
          <p className="tracking-[0.2em] uppercase text-neutral-500 mb-2 text-[0.65rem]">
            Lavorazioni e prodotti
          </p>
          <p>
            Cava di sienite e granito biellese · Estrazione e lavorazione della sienite
            della Balma · Blocchi grezzi · Lastre di sienite e granito · Pavimentazioni
            in pietra naturale (urbane, residenziali, stradali, piazze) · Rivestimenti
            in sienite (facciate, monumentali, esterni, interni) · Cordoli, basamenti,
            davanzali, soglie, zoccolature in granito · Scalinate, scale e gradini in
            pietra · Lapidi, monumenti funerari, cippi, edicole, arte cimiteriale ·
            Sculture ed elementi architettonici a vista · Arredo urbano, fontane,
            panchine in pietra · Finiture lucida, fiammata, bocciardata, spazzolata,
            sabbiata, levigata, grezza · Taglio e lavorazione su misura, su disegno e su
            progetto.
          </p>
        </div>
        <div>
          <p className="tracking-[0.2em] uppercase text-neutral-500 mb-2 text-[0.65rem]">
            Sienite Verde Balma — caratteristiche
          </p>
          <p>
            Roccia magmatica intrusiva felsica composta da plagioclasio, ortoclasio e
            anfiboli, senza quarzo libero. Pietra grigio-verdognola con riflessi
            azzurro-acciaio, ad alta resistenza compressiva (~220 MPa), bassissima
            porosità (0,15%) e resistenza al gelo ≥ 100 cicli. Adatta a esterni alpini,
            edilizia residenziale e pubblica, restauro, conservazione e architettura di
            pregio. Pietra italiana certificata, di estrazione e lavorazione artigianale.
          </p>
        </div>
        <div>
          <p className="tracking-[0.2em] uppercase text-neutral-500 mb-2 text-[0.65rem]">
            Zone servite
          </p>
          <p>
            Sede a Sagliano Micca, Biella (Piemonte). Forniamo blocchi, lastre,
            pavimentazioni e manufatti in sienite e granito a: Biella, Andorno Micca,
            Tollegno, Pralungo, Cossato, Vigliano Biellese, Campiglia Cervo, San Paolo
            Cervo, Valle Cervo, Vercelli, Novara, Torino, Milano, Lombardia, Liguria,
            Valle d'Aosta e in tutto il Nord Italia. Disponibilità all'export ed alla
            spedizione su commessa di blocchi grezzi e prodotti finiti su tutto il
            territorio nazionale e internazionale.
          </p>
        </div>
        <div>
          <p className="tracking-[0.2em] uppercase text-neutral-500 mb-2 text-[0.65rem]">
            Tradizione & territorio
          </p>
          <p>
            Erede dei picapere — i maestri scalpellini biellesi che dal 1840 hanno cavato
            la sienite della Balma a Campiglia Cervo. Ultima cava attiva della Valle
            Cervo, GMB Graniti s.r.l. continua la tradizione di estrazione e lavorazione
            della pietra alpina a oltre 1100 metri di quota. Pietra di montagna, granito
            alpino, sienite del Biellese — un materiale "Made in Biella · Made in Italy".
          </p>
        </div>
      </div>

      {/* Credits banner */}
      <div className="border-t border-[var(--border-subtle)] pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-[0.65rem] tracking-[0.25em] uppercase text-neutral-600">
        <span data-testid="footer-credits">
          Sito creato da{" "}
          <a
            href="https://studiobiellaweb.it"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[var(--accent)] hover:text-[var(--accent-hover)] transition-colors"
          >
            studiobiellaweb.it
          </a>
        </span>
        <span className="text-neutral-700">Made in Biella · Piemonte · Italia</span>
      </div>
    </footer>
  );
}
